<template>
  <div class="itinerary-row">
    <div class="left-slot"></div>
    <TransitLine :mode="'WALK'" />
    <div class="leg-box right-slot wait">
      <div style="font-weight: 700; font-size: 15px; display:flex;">
        <div style="margin-left:15px; display: flex; flex-direction: column; justify-content: center">
          <span v-if="(nextLeg.startTime - leg.endTime)/1000 >60">Vent i
            {{getDurationString((nextLeg.startTime - leg.endTime)/1000)}}</span>
          <span v-else>Ingen ventetid</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDurationString } from '@/util/itinerary';
import TransitLine from '@/components/Itinerary/TransitNodes/TransitLine.vue';
export default {
  name: 'wait-leg',
  components: {
    TransitLine,
  },
  data: function() {
    return { getDurationString };
  },
  props: { leg: Object, nextLeg: Object },
};
</script>

<style lang="scss" scoped>
.leg-box {
  border-radius: 6px;
  color: #fff;
  padding: 16px;
}
.walk {
  background-color: rgba(215, 216, 230, 0.078);
  color: $primary-700;
  border: 1px solid #efeff4;
}
.wait {
  color: $primary-500;
  opacity: 0.6;
  padding: 4px;
}

.wait > div {
  font-weight: 600 !important;
}
</style>
